import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import cx from "classnames";
import submit from "submit-form";
import { useRillContext } from "../../rill/RillReact/share/base";

function Checkboxes({
  name,
  checkboxes,
  className,
  propQuery,
  title,
  inputGroupClassName = "",
}) {
  const {
    locals: { query },
  } = useRillContext();

  let values =
    get(query, name, "").toString() || get(propQuery, name, "").toString();
  const handleChange = (event) => {
    const val = event.target.value,
      valuesArray = values ? values.split(",") : [];
    if (valuesArray.includes(val)) {
      valuesArray.splice(valuesArray.indexOf(val), 1);
    } else {
      valuesArray.push(val);
    }
    values = valuesArray.join(",");

    submit(`/actions/refresh`, {
      method: "GET",
      body: { [name]: values },
    });
  };
  if (typeof title === "string") title = { text: title };

  return (
    <div className={cx("group", className)}>
      <input type="hidden" name={name} value={values} />
      {title && (
        <div className={cx("label", title.className)}>{title.text}</div>
      )}
      <div className={inputGroupClassName}>
        {map(
          checkboxes,
          ({ className, html, href, onChange, value }, index) => {
            return (
              <label className="checkbox-input" key={index}>
                <input
                  type="checkbox"
                  value={value}
                  checked={values.includes(value)}
                  onChange={onChange || handleChange}
                />
                <span className="checkbox"></span>
                <span className="text">{html}</span>
              </label>
            );
          }
        )}
      </div>
    </div>
  );
}

export default Checkboxes;
